module.exports = __webpack_public_path__ + "img/Icon_Menu.08e5a8ef.png";